import { environment } from '@environments';
import io from 'socket.io-client';

export class Socket {
  constructor() {
    this.socket = null;
    this.timeout = null;
    this.count = 0;
  }

  open(isInvitee) {
    const token = isInvitee ? sessionStorage.getItem('token') : localStorage.getItem('token');
    this.socket = io(environment.VUE_APP_MEDIA_SOUP,
      {
        withCredentials: false,
        query: { authorization: token },
      });

    this.socket.on('disconnect', this.onDisconnect);
    this.socket.on('connect', this.onConnect);
    this.socket.on('error', error => {
      console.log('Socket media soup error:', error, this.socket);
    });

    this.socket.connect();

    return this.socket;
  }

  onDisconnect(warn) {
    console.log('Socket media soup disconnected:', warn);
    // this.exit(true);
    // if (!this.timeout) {
    //   if (this.count < 30) this.count += 5000;
    //
    //   this.timeout = setTimeout(() => {
    //     this.socket.connect();
    //     clearTimeout(this.timeout);
    //     this.timeout = null;
    //   }, this.count * 100);
    // }
  }

  onConnect() {
    console.log('Socket media soup connected');

    // this.count = 5000;
    // if (this.timeout) {
    //   clearTimeout(this.timeout);
    //   this.timeout = null;
    // }
  }

  close() {
    if (this.socket) {
      console.log('Socket media soup closed');
      this.socket.off('connect', this.socket.onConnect);
      this.socket.off('disconnect', this.socket.onDisconnect);
      this.socket.close();
    }
  }
}
